(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom_subscriptions_block"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('subscribe-custom-widget')) {
  class SubscribeCustomWidget extends HTMLElement {
      constructor() {
          super();

          this.closestSelector = 'product-page'
          const productId = this.dataset.productid;
          this.subscribeOnetimeInput = this.querySelector(`#subscribe-custom-onetime-${productId}`)
        
          this.subscribeOptionsInput = this.querySelector(`#subscribe-custom-options-${productId}`)
          this.jsSubscribeOptions = this.querySelector('.js-subscribe-options')
          this.jsDiscountLabel = this.querySelector('.js-discount-label')
          this.selectDropDown = this.querySelector('.js-subscribe-options-selected')

          this.variantId = ''

          // this.variantSwatchInputs = document.querySelectorAll('variant-selects .select__select')
        
      }

      connectedCallback() {
          
        this.getProductObject()


      
      }

      async getProductObject(){
    
          try{
            const runFetchProduct = await fetch(this.dataset.url)
            const data = await runFetchProduct.json()
          
            if(data.selling_plan_groups.length){

              //run render html plans list
              this.renderSellingPlanGroups(data)

              //run code  
              this.subscribeOnetime()

              
              this.variantProductChange(data);

                this.style.display = 'block'

            }else{
                this.style.display = 'none'
            }
          }catch(error){
            return false
          }
        
      }



    renderSellingPlanGroups(productObject){
  
      const data = productObject

    //    console.log(data)

      this.jsSubscribeOptions.innerHTML = `
        ${data.selling_plan_groups.map((item, index) => item.selling_plans.map(plan => `
            <input type="radio" 
            class="js-custom-plan-input" name="plan" 
            id="plan-${plan.id}" 
            ${index === 0 ? 'checked' : ''}
            value="${plan.id}"
            data-discount="${plan.price_adjustments[0]?.value}"
            >
            <label for="plan-${plan.id}" class="custom-plan-label">${plan.name}</label>
          `).join('')
        ).join('')
        }
      `

      if(this.closest(this.closestSelector).querySelectorAll('form input[name="selling_plan"]').length === 0){
        const createElementSelingPlan = document.createElement('input')
              createElementSelingPlan.name = 'selling_plan'
              createElementSelingPlan.type = 'hidden'
        this.closest(this.closestSelector).querySelector('.product-form form[action="/cart/add"]').prepend(createElementSelingPlan)
      }

      this.querySelectorAll('.js-custom-plan-input').forEach(input => {
        input.addEventListener('change', (e) => {
          e.preventDefault()
          //  console.log(productObject)
          //  console.log(this.variantId)
          this.closest(this.closestSelector).querySelector('form input[name="selling_plan"]').value = e.currentTarget.value
          if(this.selectDropDown){
                this.selectDropDown.textContent = e.currentTarget.nextElementSibling.textContent
                this.jsDiscountLabel.innerHTML = e.currentTarget.dataset.discount ? ' ' + e.currentTarget.dataset.discount + '% OFF' : ''

                this.subscribePriceChange(data, e.currentTarget.value)
            }
        })
      })


      this.jsDiscountLabel.innerHTML = ` ${data.selling_plan_groups[0].selling_plans[0]?.price_adjustments[0]?.value}% OFF` || ''


        

    } 


    subscribePriceChange(productObject, currentPlanId) {
      const data = productObject;
      
     
      const getCurrentVariant = data.variants.find(v => v.id == this.variantId);
  
      const getCurrentSubscribePrice = getCurrentVariant.selling_plan_allocations.find(
        allocation => allocation.selling_plan_id == currentPlanId
      );

      if (getCurrentSubscribePrice) {
        const price = (getCurrentSubscribePrice.price / 100).toFixed(2);
        const compareAtPrice = getCurrentSubscribePrice.compare_at_price;
        
        let priceHtml = '';

        
        if (compareAtPrice && compareAtPrice > getCurrentSubscribePrice.price) {
          const formattedComparePrice = (compareAtPrice / 100).toFixed(2);
         
          priceHtml += `<span class="compare-at-price">$${formattedComparePrice}</span>`;
        }

        
        priceHtml += `<span class="current-price">$${price}</span>`;

       
        const priceContainer = this.querySelector('.js-subscription-purchase-price');
        if (priceContainer) {
          priceContainer.innerHTML = priceHtml;
        }
      }
    }
 


    subscribeOnetime(){

        this.subscribeOnetimeInput.addEventListener('change', (e) => {
          if(e.currentTarget.checked){
              this.closest(this.closestSelector).querySelector('form input[name="selling_plan"]').value = '';
              if(this.selectDropDown){
                this.selectDropDown.classList.remove('active')
              }
          }
        })
        this.subscribeOptionsInput.addEventListener('change', (e) => {
       
          if(e.currentTarget.checked){
            this.closest(this.closestSelector).querySelector('form input[name="selling_plan"]').value = this.querySelector('.js-custom-plan-input:checked').value
            if( this.selectDropDown){
                 this.selectDropDown.textContent = this.querySelector('.js-custom-plan-input:checked + label').textContent
            }
          }
           
        })
        if(this.subscribeOptionsInput.checked){
          this.closest(this.closestSelector).querySelector('form input[name="selling_plan"]').value = this.querySelector('.js-custom-plan-input:checked').value
         
        }

         if(this.selectDropDown){
             this.selectDropDown.textContent = this.querySelector('.js-custom-plan-input:checked + label').textContent
          }

        this.selectDropDownToggle()
        
    }

    selectDropDownToggle(){
        if (this.selectDropDown){
             this.selectDropDown.addEventListener('click', (e) => {
                if(!e.currentTarget.classList.contains('active')){
                    e.currentTarget.classList.add('active')
                }else{
                    e.currentTarget.classList.remove('active')
                }
             })

             this.querySelectorAll('.js-custom-plan-input').forEach(item => {
              item.addEventListener('change', (e) => {
                this.selectDropDown.classList.remove('active')
              })
             })
        }
    }

    variantProductChange(data) {
        const container = this.closest(this.closestSelector).querySelector('.product-text'); 
    
    // console.log(container)

        if (!container) return;

        const changePrice = () => {
          setTimeout(() => {

              const getJsonScriptArrayIds = this.closest(this.closestSelector).querySelector('product-variants script[data-js-variant-data]'); 
         
              const getScriptJsonParse = JSON.parse(getJsonScriptArrayIds.innerHTML)
            
          
            const locationVarinaId = getScriptJsonParse.id || null

            this.variantId = locationVarinaId
             
   
            const catchVariant = (currentVariant) => {
              const getCurrentPrice = (currentVariant.price / 100).toFixed(2);
              const compareAtPrice = currentVariant.compare_at_price;
              
              let oneTimePriceHtml = '';


              if (compareAtPrice && compareAtPrice > currentVariant.price) {
                const formattedComparePrice = (compareAtPrice / 100).toFixed(2);
            
                oneTimePriceHtml += `<span class="compare-at-price">$${formattedComparePrice}</span>`;
              }
              

              oneTimePriceHtml += `<span class="current-price">$${getCurrentPrice}</span>`;


              const oneTimeContainer = this.querySelector('.js-one-time-purchase-price');
              if (oneTimeContainer) {
                oneTimeContainer.innerHTML = oneTimePriceHtml;
              }


              const planInput = this.querySelector('.js-custom-plan-input:checked');
              if (planInput) {
                this.subscribePriceChange(data, planInput.value);
              }

            
              const sellingPlanAllocation = currentVariant.selling_plan_allocations[0];
              if (sellingPlanAllocation) {
                const sellingPlanId = sellingPlanAllocation.selling_plan_id;
                const getVariantWthSellingPlan = data.selling_plan_groups
                  .flatMap(p => p.selling_plans)
                  .find(plan => plan.id == sellingPlanId);
                
                if (getVariantWthSellingPlan) {
                  const getPercentageValue = getVariantWthSellingPlan.price_adjustments[0].value.toFixed(2);
                
                  // this.jsDiscountLabel.innerHTML = `Save ${getPercentageValue}%`;
                }
              }
            };

            if (locationVarinaId) {
              const getCurrentVariantid = data.variants.find(v => v.id == locationVarinaId);
              catchVariant(getCurrentVariantid);
            } else {
              catchVariant(data.variants[0]);
            }

            
          }, 300);
        };


        changePrice();


        container.addEventListener('change', (e) => {

            changePrice();

            
        });
    }

  }

  
    customElements.define('subscribe-custom-widget', SubscribeCustomWidget);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-swatcher"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-swatcher')) {
      class ProductSwatcher extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.links = this.querySelectorAll('.product-swatcher__item');
          this.links.forEach(link => {
            link.addEventListener('click', this.handleSwatchClick.bind(this));
          });
        }

        async handleSwatchClick(event) {
          event.preventDefault();
          const target = event.currentTarget;
          const url = target.getAttribute('href');
          
          if (target.classList.contains('active')) return;

          // Update UI instantly
          this.links.forEach(l => l.classList.remove('active'));
          target.classList.add('active');
            const currentSection = this.closest('product-page') || document.querySelector('product-page') || document.querySelector('.main-product');
            const container = currentSection ? currentSection.parentNode : document.querySelector('.mount-product-page'); // Fallback

            if (container) {
                container.style.height = container.offsetHeight + 'px';
                container.style.overflow = 'hidden';
                container.closest('.shopify-section').classList.add('is-loading-product');
            }

          
            try {
              const response = await fetch(url);
              if (!response.ok) throw new Error('Network response was not ok');
              const text = await response.text();
              const parser = new DOMParser();
              const newDoc = parser.parseFromString(text, 'text/html');
              const newSection = newDoc.querySelector('product-page') || newDoc.querySelector('.main-product');

              if (currentSection && newSection) {
                 currentSection.replaceWith(newSection);

                 if (container) {
                    // Force reflow
                     newSection.offsetHeight; 
                     container.style.transition = 'height 0.4s ease'; // Match or slightly exceed opacity transition
                     container.style.height = newSection.offsetHeight + 'px';
                 }
              } else {
                 window.location.href = url;
                 return;
              }

              if(window.location.href.includes('products')){
                  window.history.pushState({ path: url }, '', url);
              }

              setTimeout(() => {
                  if (container) {
                      container.closest('.shopify-section').classList.remove('is-loading-product');
                      // Wait for transition to finish then cleanup
                      setTimeout(() => {
                          container.style.height = '';
                          container.style.overflow = '';
                          container.style.transition = '';
                      }, 400); 
                  }


               }, 600); // Trigger finish slightly earlier than 1000ms to feel snappier, or keep consistent. 
               // User originally had 1000ms. I'll stick close to it but start the fade in (remove class) at 600ms so the user sees the new content appearing.
               


            } catch (error) {
              console.error('Error fetching product:', error);
              window.location.href = url; 
            }
        }
      }

      customElements.define('product-swatcher', ProductSwatcher);
    }
  } catch(e) { console.error(e); }
})();

})();
